import { Link } from "react-router-dom";
import PublicLayout from "../../components/marketing/PublicLayout";
import { useMarketingLang } from "../../lib/useMarketingLang";
import { IMG } from "../../i18n/marketingImages";
import { ArrowRight, CheckCircle2 } from "lucide-react";

// Delt komponent for begge båt-sider – tar en `boatKey` (gl33|gl39)
// og henter alt innhold via i18n.
export default function BoatPage({ boatKey, image, testidBase }) {
  const { t } = useMarketingLang();
  const b = t[boatKey];
  return (
    <PublicLayout>
      <section className="relative min-h-[420px] flex items-end">
        <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F1A2B] via-[#0F1A2B]/70 to-[#0F1A2B]/30" />
        <div className="relative max-w-7xl mx-auto px-4 lg:px-8 py-14 lg:py-20 w-full">
          <div className="text-xs uppercase tracking-[0.42em] text-[#ECC974] mb-3">Boat Rental</div>
          <h1 className="text-4xl lg:text-6xl font-bold text-white leading-none mb-4" data-testid={`${testidBase}-title`}>
            {b.title}
          </h1>
          <p className="text-white/85 text-lg max-w-2xl">{b.subtitle}</p>
          <Link
            to="/book"
            data-testid={`${testidBase}-book`}
            className="inline-flex items-center gap-2 mt-6 rounded-full bg-[#A57F39] hover:bg-[#BD984D] transition text-white uppercase tracking-widest text-xs font-bold px-6 py-3"
          >
            {t.fleet.bookNow} <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 lg:px-8 py-14 grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-5">
          <p className="text-lg text-[#0F1A2B] leading-relaxed">{b.lead}</p>
          <div className="rounded-xl bg-[#A57F39]/10 border border-[#A57F39]/30 text-[#0F1A2B] px-4 py-3 text-sm">
            <strong>{b.pickup}</strong>
          </div>
          <h2 className="text-2xl font-bold text-[#0F1A2B] mt-6">{b.descTitle}</h2>
          {b.desc.map((p, i) => (
            <p key={i} className="text-[#0F1A2B]/80 leading-relaxed">{p}</p>
          ))}
        </div>

        <aside className="lg:sticky lg:top-24 self-start rounded-2xl border border-[#A57F39]/20 bg-white shadow-sm p-6">
          <h3 className="text-lg font-bold text-[#0F1A2B] mb-4">{b.specsTitle}</h3>
          <ul className="space-y-2 text-sm text-[#0F1A2B]/85">
            {b.specs.map((s, i) => (
              <li key={i} className="flex items-start gap-2">
                <CheckCircle2 className="h-4 w-4 text-[#A57F39] mt-0.5 shrink-0" /> {s}
              </li>
            ))}
          </ul>
          <Link
            to="/book"
            data-testid={`${testidBase}-book-aside`}
            className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#A57F39] hover:bg-[#BD984D] transition text-white uppercase tracking-widest text-xs font-bold px-6 py-3"
          >
            {t.fleet.bookNow} <ArrowRight className="h-4 w-4" />
          </Link>
        </aside>
      </section>
    </PublicLayout>
  );
}
